import Episode from "@/containers/Episode";
import Episodes from "@/containers/Episodes";
import { AudioPlayerContextProvider } from "@/contexts/GlobalAudioPlayerContext";
import { Episode as EpisodeT } from "@/types/Episode";
import { pluralize } from "@/utils";

interface Meta {
  total_matches: number;
  estimated_mentions: number;
}

interface PreviewMentionListProps {
  meta: Meta;
  mentions: EpisodeT[];
}

const PreviewMentionList: React.FC<PreviewMentionListProps> = (props) => {
  return (
    <div>
      <div className="border-top pt-5 my-5">
        {props.meta.total_matches === 0 && (
          <div className="flex flex-col items-center">
            <h3>{L.MENTIONS_QUERYBUILDER_PREVIEW_NO_RESULTS_HEADER}</h3>
            <p className="text-center">
              {L.MENTIONS_QUERYBUILDER_PREVIEW_NO_RESULTS_TEXT}
            </p>
          </div>
        )}

        {props.meta.total_matches > 0 && (
          <p className="lead" data-testid="estimated-mention-count">
            {`${L.MENTIONS_QUERYBUILDER_PREVIEW_TEXT_PRE} ${
              props.meta.estimated_mentions
            } ${pluralize(
              props.meta.estimated_mentions,
              L.MENTIONS_QUERYBUILDER_PREVIEW_MENTIONS_SINGULAR,
              L.MENTIONS_QUERYBUILDER_PREVIEW_MENTIONS_PLURAL
            )} ${L.MENTIONS_QUERYBUILDER_PREVIEW_TEXT_POST}`}
          </p>
        )}
      </div>

      {props.mentions.length > 0 && (
        <AudioPlayerContextProvider>
          <Episodes>
            {props.mentions.map((ep) => (
              <Episode
                key={ep.episode_uuid}
                {...ep}
                {...ep?.post_data}
                hideTags
                hideActions
                hideSimilar
              />
            ))}
          </Episodes>
        </AudioPlayerContextProvider>
      )}
    </div>
  );
};

export default PreviewMentionList;
